export default __webpack_public_path__ + "static/media/ic-general-settings.d3322540.svg";